export default __webpack_public_path__ + "static/P_SearchThumb_IN-8401WQHD-04f324e533e6a8e42d71d85960efebd7.webp";